import { TriStateFilter } from './types';

export const parseTriStateFilter = (value: TriStateFilter): boolean | undefined => {
  if (value === 'all') {
    return undefined;
  }

  return value === 'true';
};

export const formatBooleanLabel = (value: boolean): string => (value ? 'Yes' : 'No');

export const formatQcStatusLabel = (value: boolean): string => (value ? 'QCed' : 'Not QCed');
